// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"76b904d6","239":"eab0352a","667":"d49d5e6e","977":"fa8bdf19"}[chunkId] + ".chunk.js";
};